import { useTranslation } from 'react-i18next'
import React from 'react'

import FullPageTemplate from '../../../../components/templates/FullPageTemplate'
import MPageHeader from '../../../../components/presentation/M.PageHeader'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../../components/helpers/Separator'

const MServiceOrdersPublicListPage = () => {
  const { t } = useTranslation('settings')

  return (
    <FullPageTemplate>
      <MPageHeader title={t('listServiceOrders:title')} />
      <PageHeader />
      <PageContent />
      <Separator />
    </FullPageTemplate>
  )
}

export default MServiceOrdersPublicListPage
